import { service } from '@ember/service'
import type { IntlService } from 'ember-intl'
import Component from '@glimmer/component'
import { hash, array } from '@ember/helper'
import { t } from 'ember-intl'
import { SideNavAccordionItem, SideNavAccordionList } from 'teacher-ui-client/components/side-nav/accordion'
import type { TOC } from '@ember/component/template-only'
import { eq } from 'ember-truth-helpers'
import { SideNavGroup } from 'teacher-ui-client/components/side-nav/group'
import { SideNavItem } from 'teacher-ui-client/components/side-nav/item'
import { SideNavIconComponent } from 'teacher-ui-client/components/side-nav/icon'
import bookUnfilled from '@images/icons/book-unfilled.svg'

interface SideNavProductGroupSignature {
  Args: {
    product: string
  }
  Blocks: {
    default: []
  }
  Element: HTMLDivElement
}

export class SideNavProductGroup extends Component<SideNavProductGroupSignature> {
  @service intl!: IntlService

  get linkTo() {
    return `subscription-type.lessons.${this.args.product}.previews`
  }

  get productInfo() {
    switch (this.args.product) {
      case 'reading-eggs':
        return {
          menuGroupLabel: this.intl.t('products.re'),
          linkTo: 'subscription-type.lessons.reading-eggs.previews',
          precinct: 'reading-eggs-reading',
          currentWhen: 'subscription-type.lessons.reading-eggs.previews',
        }
      case 'reading-eggspress':
        return {
          menuGroupLabel: this.intl.t('products.rex'),
          linkTo: 'subscription-type.lessons.reading-eggspress.previews',
          precinct: 'reading-eggspress-reading',
          currentWhen: 'subscription-type.lessons.reading-eggspress.previews',
        }
      case 'fast-phonics':
        return {
          menuGroupLabel: this.intl.t('products.fp'),
          linkTo: 'subscription-type.lessons.fast-phonics.previews',
          precinct: 'fast-phonics-peaks',
          currentWhen: 'subscription-type.lessons.fast-phonics.previews',
        }
      case 'mathseeds':
        return {
          menuGroupLabel: this.intl.t('products.mathseeds'),
          linkTo: 'subscription-type.lessons.mathseeds.previews',
          precinct: 'mathseeds-lessons',
          currentWhen: 'subscription-type.lessons.mathseeds.previews',
        }
      case 'mathseeds-prime':
        return {
          menuGroupLabel: this.intl.t('products.mathseeds-prime'),
          linkTo: 'subscription-type.lessons.mathseeds-prime.previews',
          precinct: 'mathseeds-prime-lessons',
          currentWhen: 'subscription-type.lessons.mathseeds-prime.previews',
        }
      case 'writing-legends':
        return {
          menuGroupLabel: undefined,
          linkTo: 'subscription-type.lessons.writing-legends.previews',
          precinct: 'writing-legends-writing',
          currentWhen: 'subscription-type.lessons.writing-legends.previews',
        }
    }
  }

  <template>
    <SideNavGroup @label={{this.productInfo.menuGroupLabel}} @removeDividers={{true}} ...attributes>
      <SideNavItem
        @linkTo={{this.productInfo.linkTo}}
        @linkToQuery={{hash precinct=this.productInfo.precinct pageNumber=1}}
        @currentWhen={{this.productInfo.currentWhen}}
      >
        <SideNavIconComponent @url={{bookUnfilled}} @alt="Sidenav book" />
        {{t "sideNav.lessons"}}
      </SideNavItem>
      {{#unless (eq @product "mathseeds-prime")}}
        <SideNavAssignmentsGroup @product={{@product}} />
      {{/unless}}
      {{yield}}

    </SideNavGroup>
  </template>
}

interface SideNavAssignmentsSignature {
  Args: {
    product: string
  }
}

const SideNavAssignmentsGroup: TOC<SideNavAssignmentsSignature> = <template>
  <SideNavAccordionList @phosphorIcon="phosphor-calendar-check-fill" @label={{t "sideNav.assignments"}}>
    <SideNavAccordionItem @route="assignments.product.manage.current" @models={{array @product}}>
      {{t "assignments.manage.sideNav"}}
    </SideNavAccordionItem>

    <SideNavAccordionItem @route="assignments.product.create" @models={{array @product}}>
      {{t "assignments.create.sideNav"}}
    </SideNavAccordionItem>
  </SideNavAccordionList>
</template>
